export const REVIEW_NOTICE =
    "Preliminary — requires review by a licensed fire protection designer/PE before construction.";

export default function ReviewNotice({ testId = "review-notice" }) {
    return (
        <p
            className="mt-3 text-sm leading-relaxed text-amber-200"
            data-testid={testId}
        >
            {REVIEW_NOTICE}
        </p>
    );
}
